export default __webpack_public_path__ + "static/media/68.6f9fc5e5.jpeg";